import { TFunction } from 'i18next';
import { map } from 'rxjs/operators';
import { apiClient } from 'src/js/api';
import { rxTaskFactory } from 'src/js/helper/mobx-tasks';
import { NtpStatisticsResponse } from 'src/js/model/api/response/ntp-statistics-response';
import { ValidateNtpServerResponse } from 'src/js/model/api/response/validate-ntp-server-response';
import { NtpServerStatus } from 'src/js/model/ntp-server-status';
import { handleValidateNtpServerResponse } from 'src/js/task/handler/settings-date-time-handlers';
import { NetworkTaskGenerator, SameTypeNetworkTaskGenerator } from 'src/js/util/global-type';

export const createGetNtpStatisticsTask: SameTypeNetworkTaskGenerator<NtpStatisticsResponse> = () =>
  rxTaskFactory(() => apiClient.settingsDateTimeController.getNtpStatistics());

export const createValidateNtpServerTask: NetworkTaskGenerator<ValidateNtpServerResponse, NtpServerStatus> = (
  t: TFunction,
) =>
  rxTaskFactory((server: string) =>
    apiClient.settingsDateTimeController
      .validateNtpServer(server)
      .pipe(
        map<ValidateNtpServerResponse, NtpServerStatus>(
          (response: ValidateNtpServerResponse): NtpServerStatus => handleValidateNtpServerResponse(response, t),
        ),
      ),
  );
